import { useState } from "react";
import type { Kanal, Lieferadresse } from "../api";

/** Was die Kasse zum OTP-Anfordern liefert: Kontakt, Kanal und (bei Lieferung) die Adresse. */
export interface KassenEingabe {
  telefon: string;
  kanal: Kanal;
  lieferadresse?: Lieferadresse;
}

interface Props {
  laedt: boolean;
  onAnfordern: (eingabe: KassenEingabe) => void;
}

const LEERE_ADRESSE: Lieferadresse = { strasse: "", hausnummer: "", plz: "", ort: "" };

/** Die Kasse: Telefonnummer, Kanal (Lieferung/Abholung) und die strukturierte Lieferadresse. */
export function Kasse({ laedt, onAnfordern }: Props) {
  const [telefon, setTelefon] = useState("");
  const [kanal, setKanal] = useState<Kanal>("LIEFERUNG");
  const [adresse, setAdresse] = useState<Lieferadresse>(LEERE_ADRESSE);

  const absenden = (e: React.FormEvent) => {
    e.preventDefault();
    onAnfordern({
      telefon: telefon.trim(),
      kanal,
      ...(kanal === "LIEFERUNG" ? { lieferadresse: adresse } : {}),
    });
  };

  const setzeAdresse = (feld: keyof Lieferadresse, wert: string) =>
    setAdresse((alt) => ({ ...alt, [feld]: wert }));

  return (
    <form className="kasse" onSubmit={absenden}>
      <label className="feld">
        <span>Telefonnummer</span>
        <input
          type="tel"
          required
          value={telefon}
          onChange={(e) => setTelefon(e.target.value)}
          placeholder="+43 …"
        />
      </label>

      <fieldset className="kanalwahl">
        <legend>Wie möchtest du bestellen?</legend>
        <label>
          <input
            type="radio"
            name="kanal"
            checked={kanal === "LIEFERUNG"}
            onChange={() => setKanal("LIEFERUNG")}
          />
          Lieferung
        </label>
        <label>
          <input
            type="radio"
            name="kanal"
            checked={kanal === "ABHOLUNG"}
            onChange={() => setKanal("ABHOLUNG")}
          />
          Abholung
        </label>
      </fieldset>

      {kanal === "LIEFERUNG" && (
        <fieldset className="adresse">
          <legend>Lieferadresse</legend>
          <div className="adresse-zeile">
            <label className="feld wachsen">
              <span>Straße</span>
              <input
                required
                value={adresse.strasse}
                onChange={(e) => setzeAdresse("strasse", e.target.value)}
              />
            </label>
            <label className="feld schmal">
              <span>Hausnummer</span>
              <input
                required
                value={adresse.hausnummer}
                onChange={(e) => setzeAdresse("hausnummer", e.target.value)}
              />
            </label>
          </div>
          <div className="adresse-zeile">
            <label className="feld schmal">
              <span>PLZ</span>
              <input
                required
                value={adresse.plz}
                onChange={(e) => setzeAdresse("plz", e.target.value)}
              />
            </label>
            <label className="feld wachsen">
              <span>Ort</span>
              <input
                required
                value={adresse.ort}
                onChange={(e) => setzeAdresse("ort", e.target.value)}
              />
            </label>
          </div>
        </fieldset>
      )}

      <button type="submit" className="knopf primaer gross" disabled={laedt}>
        {laedt ? "Wird geprüft …" : "Bestellung prüfen & Code anfordern"}
      </button>
    </form>
  );
}
